export default "__VITE_ASSET__B_lBvTPk__"